import { createSlice } from '@reduxjs/toolkit';
import {
  addToCart,
  removeCart,
  fetchCart,
  applyCoupon,
  createOrder,
  fetchOrders,
  fetchOrder,
  createPayment,
  verifyPayment,
  updateOrder,
} from '../actions/room.action';

const initialState = {
  cart: {
    data: [],
    total: 0,
    isLoading: false,
    isNeedReloadData: true,
  },
  coupon: {
    data: [],
    isLoading: false,
    isNeedReloadData: false,
  },
  order: {
    data: [],
    detail: null,
    verifyPaymentResult: null,
    detailIsLoading: false,
    isLoading: false,
    isNeedReloadData: true,
  },
};

export const roomReducer = createSlice({
  name: 'Room',
  initialState,
  reducers: {
    reloadOrders: state => {
      state.order.isNeedReloadData = true;
    },
    resetOrdersData: state => {
      state.order.data = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCart.pending, state => {
        state.cart.isLoading = true;
        state.cart.isNeedReloadData = false;
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.cart = { ...state.cart, data, isLoading: false };
        }
      })
      .addCase(fetchCart.rejected, state => {
        state.cart = { ...state.cart, isLoading: false };
      })
      .addCase(addToCart.pending, state => {
        state.cart = {
          ...state.cart,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(addToCart.fulfilled, state => {
        state.cart = {
          ...state.cart,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(addToCart.rejected, state => {
        state.cart = { ...state.cart, isLoading: true };
      })
      .addCase(removeCart.pending, state => {
        state.cart = {
          ...state.cart,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(removeCart.fulfilled, state => {
        state.cart = {
          ...state.cart,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(removeCart.rejected, state => {
        state.cart = {
          ...state.cart,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(applyCoupon.pending, state => {
        state.coupon = {
          ...state.coupon,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(applyCoupon.fulfilled, (state, action) => {
        if (action.payload?.data?.result) {
          const { data } = action.payload;
          // const existedCoupons = state.coupon.data.filter(
          //   coupon => coupon.code === action.meta.arg.couponCode
          // );
          // if (existedCoupons.length === 0) {
          state.coupon = {
            ...state.coupon,
            data: [
              // ...state.coupon.data,
              { code: action.meta.arg.couponCode, ...data },
            ],
            isLoading: false,
            isNeedReloadData: true,
          };
          // } else {
          //   state.coupon = {
          //     ...state.coupon,
          //     isLoading: false,
          //   };
          // }
        } else {
          state.coupon = {
            ...state.coupon,
            isLoading: false,
          };
        }
      })
      .addCase(applyCoupon.rejected, state => {
        state.coupon = {
          ...state.coupon,
          isLoading: false,
        };
      })
      .addCase(createOrder.pending, state => {
        state.order = {
          ...state.order,
          data: [],
          isLoading: true,
        };
        state.coupon = { ...state.coupon, data: [] };
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.order = {
          ...state.order,
          detail: data,
          isLoading: false,
          isNeedReloadData: false,
        };
        state.cart.isNeedReloadData = true;
      })
      .addCase(createOrder.rejected, state => {
        state.order = {
          ...state.order,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(createPayment.pending, state => {
        state.order = {
          ...state.order,
          data: [],
          isLoading: true,
        };
      })
      .addCase(createPayment.fulfilled, state => {
        state.order = {
          ...state.order,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(createPayment.rejected, state => {
        state.order = {
          ...state.order,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(verifyPayment.pending, state => {
        state.order = {
          ...state.order,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(verifyPayment.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const { status, order } = action.payload.data;
          state.order = {
            ...state.order,
            detail: order,
            verifyPaymentResult: status,
            isLoading: false,
            isNeedReloadData: true,
          };
        } else {
          state.order = {
            ...state.order,
            isLoading: false,
            isNeedReloadData: true,
          };
        }
      })
      .addCase(verifyPayment.rejected, state => {
        state.order = {
          ...state.order,
          isLoading: false,
          isNeedReloadData: true,
        };
      })
      .addCase(fetchOrders.pending, state => {
        state.order = {
          ...state.order,
          verifyPaymentResult: null,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const { data, total } = action.payload;
          state.order = {
            ...state.order,
            data: [...state.order.data, ...data],
            total,
            isLoading: false,
          };
        }
      })
      .addCase(fetchOrders.rejected, state => {
        state.order = {
          ...state.order,
          isLoading: false,
        };
      })
      .addCase(fetchOrder.pending, state => {
        state.order = {
          ...state.order,
          detailIsLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const { data } = action.payload;
          state.order = {
            ...state.order,
            detail: data,
            detailIsLoading: false,
          };
        }
      })
      .addCase(fetchOrder.rejected, state => {
        state.order = {
          ...state.order,
          detailIsLoading: false,
        };
      })
      .addCase(updateOrder.pending, state => {
        state.order = {
          ...state.order,
          detailIsLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const { data } = action.payload;
          state.order = {
            ...state.order,
            detail: data,
            detailIsLoading: false,
            isNeedReloadData: true,
          };
        }
      })
      .addCase(updateOrder.rejected, state => {
        state.order = {
          ...state.order,
          detailIsLoading: false,
        };
      });
  },
});

export const { reloadOrders, resetOrdersData } = roomReducer.actions;

export default roomReducer.reducer;
